export const getPathname = () => {
  const { pathname } = window.location;

  return pathname.endsWith('/') ? pathname : `${pathname}/`;
};
